export const convertUrlsToLinks = text => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.replace(
    urlRegex,
    match => `<a href="${match}" target="_blank">${match}</a>`,
  );
};

// Mirrors the backend COMMON_TLDS used in BroadcastMessage#normalize_sms_urls_for_tracking
const COMMON_TLDS = [
  'com',
  'org',
  'net',
  'io',
  'co',
  'edu',
  'gov',
  'mil',
  'info',
  'biz',
  'us',
  'uk',
  'ca',
  'au',
  'de',
  'fr',
  'es',
  'it',
  'nl',
];

// Strips https:// (and partial variants like https:/ or https:) from URLs
// with recognized TLDs for character counting. The backend prepends https://
// to bare URLs for link tracking, but those characters should not count
// against the user's 320 character limit. Partial protocols are also stripped
// to avoid count jumps while the user is mid-edit.
export const stripUrlProtocolForCounting = text => {
  if (!text) return text;

  const tldPattern = COMMON_TLDS.join('|');
  const urlPattern = new RegExp(
    `https:\\/{0,2}((?:www\\.)?[a-zA-Z0-9][-a-zA-Z0-9]*(?:\\.[a-zA-Z0-9][-a-zA-Z0-9]*)*\\.(?:${tldPattern}))`,
    'gi',
  );

  return text.replace(urlPattern, '$1');
};

// Mirrors the backend Sms::Normalizer REPLACEMENTS map. Typographic characters
// (curly quotes, dashes, ellipsis, non-breaking spaces) force a text into UCS-2
// encoding -- cutting capacity from 160 to 67 chars/segment -- so they are
// replaced with plain GSM-7 equivalents before sending. Emoji are intentionally
// untouched. Keep this in sync with app/services/sms/normalizer.rb.
const SMS_NORMALIZE_REPLACEMENTS = [
  [/[‘’‚′]/g, "'"], // curly single quotes, prime
  [/[“”„″«»]/g, '"'], // curly double quotes, guillemets
  [/[–—―]/g, '-'], // en / em / horizontal dash
  [/…/g, '...'], // ellipsis
  [/[\u00a0\u2009\u200a\u202f]/g, ' '], // non-breaking / thin / narrow spaces
  [/•/g, '*'], // bullet
  [/\u00ad/g, ''], // soft hyphen
];

// Replace typographic characters with their plain GSM-7 equivalents.
export const normalizeSmsText = text => {
  if (!text) return text;

  return SMS_NORMALIZE_REPLACEMENTS.reduce(
    (acc, [pattern, replacement]) => acc.replace(pattern, replacement),
    text,
  );
};
